// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".WhVdZ{max-width:1248px;max-width:78rem;width:100%;margin:0 auto 4rem}@media(max-width:1439px){.WhVdZ{padding:0 2.5rem}}@media(max-width:1023px){.WhVdZ{padding:0 2rem}}@media(max-width:767px){.WhVdZ{padding:0 1.5rem;margin-bottom:2.25rem}}._11ax8{display:grid;grid-template-columns:2fr minmax(0,1fr);grid-gap:32px 24px;gap:32px 24px;grid-gap:2rem 1.5rem;gap:2rem 1.5rem;grid-template-rows:auto 1fr;grid-template-areas:\"player sidebar\" \"content sidebar\"}@media(max-width:1023px){._11ax8{grid-template-columns:minmax(0,1fr);grid-gap:1.5rem;gap:1.5rem;grid-template-areas:\"player\" \"sidebar\" \"content\"}}._3Czry{grid-area:player}._1T2OF{grid-area:sidebar;padding-bottom:1rem}._1oHeI{grid-area:content}@media(min-width:1440px){._25go2{width:680px}}._25go2:not(:last-child){border-bottom:2px solid #dcdddd}._1as0f{margin-bottom:2rem}._2A9k4{display:none}._2A9k4._2GD0F{display:block}._3eYFl{padding:1.5rem;background-color:#fff;border-radius:.5rem;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;grid-gap:12px;gap:12px;grid-gap:.75rem;gap:.75rem}._3eYFl,._3aVJS{margin-bottom:1.5rem}._1FndV{margin:1.53rem 0}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "WhVdZ",
	"wrapper": "_11ax8",
	"player": "_3Czry",
	"sidebar": "_1T2OF",
	"content": "_1oHeI",
	"tabs": "_25go2",
	"episodeList": "_1as0f",
	"paymentOption": "_2A9k4",
	"showPaymentOption": "_2GD0F",
	"enrollPending": "_3eYFl",
	"installApp": "_3aVJS",
	"breadcrumb": "_1FndV"
};
module.exports = exports;
